import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useWindowSize } from '../../helpers/hooks/hookWindowsSize'

interface ImageSize {
  height: number
  width: number
}

interface CardProps {
  title: string
  image: string
  buttonTitle: string
  color: string
  url: string
  imageSize: ImageSize
}

const Card = ({
  title,
  image,
  buttonTitle,
  color,
  url,
  imageSize,
}: CardProps) => {
  const { t } = useTranslation()
  let navigate = useNavigate()
  const sizeWidth = useWindowSize().width

  return (
    <>
      <div
        className={`${
          sizeWidth > 767 ? 'm-2 width-100' : 'my-2'
        } plan-card border-card-${color}`}
      >
        <img
          src={image}
          alt={`${t(title)}`}
          height={imageSize.height}
          width={imageSize.width}
          className="my-2"
        />
        <div className="container-content-title">
          <span className="plan-content-title">{`${t(title)}`}</span>
        </div>
        <div className="container-button-get-started">
          <button
            type="submit"
            className={`button-get-started-${color} col-12`}
            onClick={() => navigate(url)}
          >
            {`${t(buttonTitle)}`}
          </button>
        </div>
      </div>
    </>
  )
}

export default Card
